import { Controller } from "@hotwired/stimulus";
import DOMPurify from "dompurify";

// import Rails from "rails";
export default class extends Controller {
  static targets = [
    "reeInput",
    "eeInput",
    "counter",
    "newEEFields",
    "addEE",
    "radio",
    "feedback",
    "endDate",
  ];

  buildUserOptions(results) {
    return results.users
      .map((user) => {
        return `<option value="${DOMPurify.sanitize(
          user.id
        )}">${DOMPurify.sanitize(user.name)}</option>`;
      })
      .join("\n");
  }

  buildEeOptions(results) {
    return results
      .map((ee) => {
        return `
          <option value="${DOMPurify.sanitize(ee.id)}">${DOMPurify.sanitize(
          ee.name
        )}</option>
        `;
      })
      .join("\n");
  }

  updateReesList(id = null, count = null) {
    const enterpriseId = id || event.target.value;
    const inputCount = count || event.target.dataset.count;
    const target = this.reeInputTargets.find(
      (input) => input.dataset.count === inputCount
    );
    const path = "/enterprises/" + enterpriseId + ".json";
    target.innerHTML = "";
    $.get(path)
      .done((results) => {
        const options = this.buildUserOptions(results);
        target.innerHTML = options;
      })
      .fail((err) => (target.innerHTML = ""));
  }

  displayAllEEs() {
    const eeSelect = this.eeInputTargets.find(
      (input) => input.dataset.count === event.target.dataset.count
    );
    $.get("/enterprises.json")
      .done((results) => {
        eeSelect.innerHTML = this.buildEeOptions(results);
      })
      .fail((err) => (target.innerHTML = ""));
    event.target.parentElement.remove();
  }

  addNewEEFields() {
    // Please, don't insult me. For manual JS validation purposes, I had to actually remove these fields from the DOM
    // in order for them not to block presence validation when not used.
    this.newEEFieldsTarget.innerHTML = `
      <div class="row">
        <div class="col-sm">
          <div class="form-group string optional pp_new_ee_name" data-children-count="1">
            <label class="form-control-label string optional" for="pp_new_ee_name">
              Nom de l'entreprise
            </label>
            <input class="form-control string optional form-control input-style"
              data-target="validation-demande.input"
              type="text"
              name="pp[new_ee_name]"
              id="pp_new_ee_name"
              data-kwimpalastatus="alive"
              data-kwimpalaid="1587399199653-5"
              data-action="focusout->validation-demande#enableSubmitIfAllInputFilled"
              data-controller="uppercase-input">
          </div>
        </div>
        <div class="col-sm">
          <div class="form-group string optional pp_new_ee_siret" data-children-count="1">
            <label class="form-control-label string optional" for="pp_new_ee_siret">SIRET</label>
            <input class="form-control string optional form-control input-style"
              data-action="
                focusout->pp-form#checkSiret
                focusout->validation-demande#enableSubmitIfAllInputFilled
                input->pp-form#reinitInput"
              data-target="validation-demande.input"
              type="text"
              name="pp[new_ee_siret]"
              id="pp_new_ee_siret">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <div class="form-group string optional pp_new_ee_user_name" data-children-count="1">
          <label class="form-control-label string optional" for="pp_new_ee_user_name">
            Nom du responsable
          </label>
          <input class="form-control string optional form-control input-style"
            data-target="validation-demande.input" type="text" name="pp[new_ee_user_name]"
            id="pp_new_ee_user_name"
            data-kwimpalastatus="alive"
            data-kwimpalaid="1587399199653-6"
            data-action="focusout->validation-demande#enableSubmitIfAllInputFilled">
          </div>
        </div>
        <div class="col-sm">
          <div class="form-group email optional pp_new_ee_user_email"
            data-children-count="1">
            <label class="form-control-label email optional" for="pp_new_ee_user_email">
              Email du responsable
            </label>
            <input class="form-control string email optional form-control input-style"
              data-target="validation-demande.input"
              data-action="
                focusout->pp-form#checkEmailREE
                focusout->validation-demande#enableSubmitIfAllInputFilled
                input->pp-form#reinitInput"
              "
              type="email"
              name="pp[new_ee_user_email]"
              id="pp_new_ee_user_email"
              data-kwimpalastatus="alive"
              data-kwimpalaid="1587399199653-7">
            </div>
        </div>
      </div>
      <br>
      <small id="cancel" class="form-text text-muted ajouter" data-action="click->pp-form#removeNewEEFields"><strong>Annuler la création de l'entreprise extérieure</strong></small>
    `;
    this.addEETarget.classList.add("hidden");
    // Remove regular EE fields from validation if empty
    this.eeInputTargets.forEach((target) => {
      if (target.selectedIndex === 0) {
        target.dataset.target = "";
      }
    });

    document
      .querySelector(".scrollable-box")
      .scrollTo(0, document.querySelector(".scrollable-box").scrollHeight);
  }

  removeNewEEFields() {
    this.newEEFieldsTarget.innerHTML = "";
    this.addEETarget.classList.remove("hidden");
    // Reset Stimulus targets for validation
    this.eeInputTargets.forEach((target) => {
      target.dataset.target = "validation-demande.select";
    });
  }

  loadFoundEe(event) {
    const newOption = new Option(
      event.currentTarget.dataset.name,
      event.currentTarget.dataset.id,
      true,
      true
    );
    const eeInput = this.eeInputTargets[this.eeInputTargets.length - 1];
    eeInput.add(newOption);
    // Need to update list of corresponding REEs. To do that, need to pass the counter of EE inputs, in case there are multiple ones
    const inputCount =
      event.currentTarget.dataset.count || eeInput.dataset.count;
    this.updateReesList(event.currentTarget.dataset.id, inputCount);
    this.newEEFieldsTarget.remove();
    this.reeInputTarget.click();
    // document.querySelector('button.marin-btn').disabled = false;
  }

  reinitInput(event) {
    event.currentTarget.classList.remove("is-invalid");
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.remove();
    }
  }

  loadRees(event) {
    const id = event.currentTarget.dataset.id || event.currentTarget.value;
    const name =
      event.currentTarget.dataset.name ||
      event.currentTarget.selectedOptions[0].label;
    const newOption = new Option(name, id, true, true);
    event.currentTarget.add(newOption);
    // Need to update list of corresponding REEs. To do that, need to pass the counter of EE inputs, in case there are multiple ones
    const inputCount = event.currentTarget.dataset.count;
    this.updateReesList(id, inputCount);
  }

  checkSiret(event) {
    const input = event.currentTarget;
    if (!input.value) return false;

    $.get(`/check_siret/${input.value}.json`)
      .done((results) => {
        if (results) {
          input.classList.add("is-invalid");
          input.insertAdjacentHTML(
            "afterend",
            `
          <div class="invalid-feedback" data-target="pp-form.feedback">
            <p>L'entreprise ${DOMPurify.sanitize(
              results.enterprise.name
            )} est déjà enregistrée.</p>
            <p class="continue-with-ee" data-id="${DOMPurify.sanitize(
              results.enterprise.id
            )}" data-name="${DOMPurify.sanitize(
              results.enterprise.name
            )}" data-action="click->pp-form#loadFoundEe"><u>Continuer avec cette entreprise ?</u></p>
          </div>
        `
          );
        }
      })
      .fail((err) => console.log(err));
  }

  checkEmailREE(event) {
    const input = event.currentTarget;
    if (!input.value) return false;
    const data = new FormData();
    data.append("email", input.value);

    Rails.ajax({
      type: "post",
      url: `/check_email`,
      data: data,
      success: (results) => {
        if (results) {
          console.log(results);
          input.classList.add("is-invalid");
          input.insertAdjacentHTML(
            "afterend",
            `
            <div class="invalid-feedback" data-target="pp-form.feedback">
              <p>Un utilisateur L'Oréal est déjà enregistré avec cet email.</p>
            </div>
          `
          );
        }
      },
    });
  }

  setEndDate(event) {
    if (
      this.radioTargets.some((radio) => radio.checked && radio.value === "pa")
    ) {
      console.log(event.currentTarget.value);
      const regex = /(\d{4})(.*)/;
      const year = Number.parseInt(
        event.currentTarget.value.match(regex)[1],
        10
      );
      const date = event.currentTarget.value.replace(regex, `${year + 1}$2`);
      this.endDateTarget.value = date;
    }
  }
}
